export interface FeatureFlag {
  enabled: boolean;
  allowedUsers?: string[];
  allowedTeams?: string[];
}

export const FEATURE_FLAGS: Record<string, FeatureFlag> = {
  CUSTOM_TEAM_SIZES_BRAND_KIT: {
    enabled: false,
    allowedUsers: ["brayden@easil.com"],
    allowedTeams: []
  },
  CUSTOM_TEAM_SIZES_CATALOGUE_DROPDOWN: {
    enabled: false,
    allowedUsers: ["brayden@easil.com"],
    allowedTeams: []
  }
};

interface UserLike {
  email?: string | null;
}

export const isFlagEnabledFor = (
  flag: FeatureFlag | undefined,
  user?: UserLike | null,
  teamId?: string | null
): boolean => {
  if (!flag) return false;
  if (flag.enabled) return true;
  const email = user?.email?.toLowerCase();
  if (
    email &&
    flag.allowedUsers?.some(allowed => allowed.toLowerCase() === email)
  )
    return true;
  if (teamId && flag.allowedTeams?.includes(teamId)) return true;
  return false;
};

export const isCustomTeamSizesBrandKitEnabled = (
  user?: UserLike | null,
  teamId?: string | null
): boolean =>
  isFlagEnabledFor(FEATURE_FLAGS.CUSTOM_TEAM_SIZES_BRAND_KIT, user, teamId);

export const isCustomTeamSizesCatalogueDropdownEnabled = (
  user?: UserLike | null,
  teamId?: string | null
): boolean =>
  isFlagEnabledFor(
    FEATURE_FLAGS.CUSTOM_TEAM_SIZES_CATALOGUE_DROPDOWN,
    user,
    teamId
  );
